/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreviousQuestion/view.blocks to change it.
import ArrowLeft from 'DesignSystem/Svgs/ArrowLeft/index'
import ButtonIconOutline from 'DesignSystem/ButtonIconOutline/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function PreviousQuestion({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientLastName/PreviousQuestion",
  onClick
  
}) {
  return (<React.Fragment
>
<ButtonIconOutline
  viewPath={`${viewPath}/ButtonIconOutline`}
 width={32}
 height={32}
 marginRight={10}
 onClick={onClick}
>
{childProps => (
<ArrowLeft
{...childProps}
  viewPath={`${viewPath}/ArrowLeft`}
 stroke="#303030"
 width={12}
 height={12}
/>
)}
</ButtonIconOutline>
{children}
</React.Fragment>)
}